import {
  Backdrop,
  Grid,
  CircularProgress,
  Switch,
  IconButton,
  Icon,
  Select,
  MenuItem,
  Checkbox,
  FormControl,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import TLinkApi from "services/tlink.api";
import DeduplicationClient from "./deduplicationSecurity";

import OtherSecurityClient from "./otherSecurity";
import GroupDeduplicationClient from "./GroupDeduplicationSecurity";
import ResearchDefenderClient from "./researchDefender";

const OPTIONS = ["Fake", "Suspicious", "Real"];

const SecurityConfiguration = () => {
  let navigate = useNavigate();
  const { setClient, setIsEdit, isEdit } = useOutletContext();
  const [confiqIsEdit, setConfigIsEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const {
    control,
    watch,
    handleSubmit,
    register,
    formState: { errors },
    setValue,
    reset,
  } = useForm({
    defaultValues: {
      maxLoi: "",
      minLoi: "",
      minLoiIsActive: false,
      maxLoiIsActive: false,
      researchDefenderScore: 0,
      uniqueIp: false,
      uniqueUser: false,
      personaFingerprint: false,
      countryMismatch: false,
      researchDefender: false,
      digitalFingerprint: false,
      groupDeduplicationUniqueIp: false,
      groupDeduplicationUniqueUser: false,
      duplicateToggle: false,
      rdDuplicateScore: 0,
      blockedUser: false,
      deviceFingerprint: false,
      blockedIp: false,
      verisoulEnable: false,
      verisoulDecision: "",
    },
  });
  let { id } = useParams();

  let uniqueIp = watch("uniqueIp");
  let uniqueUser = watch("uniqueUser");
  let researchDefender = watch("researchDefender");
  let countryMismatch = watch("countryMismatch");
  let minLoiIsActive = watch("minLoiIsActive");
  let maxLoiIsActive = watch("maxLoiIsActive");
  let maxLoi = watch("maxLoi");
  let minLoi = watch("minLoi");
  let digitalFingerprint = watch("digitalFingerprint");

  let { enqueueSnackbar } = useSnackbar();

  const save = async (data) => {
    setIsLoading(true);
    let payload = { ...data };
    payload.minLoi = parseInt(data.minLoi);
    payload.maxLoi = parseInt(data.maxLoi);
    payload.researchDefenderScore = parseInt(data.researchDefenderScore);
    if (confiqIsEdit === true) {
      try {
        let result = await TLinkApi.put(
          `clients/${id}/securityConfig`,
          payload,
        );
        enqueueSnackbar(result?.message, {
          variant: "success",
        });
        setIsLoading(false);
        navigate(`/clients/${id}/clientFilters/edit`);
        setIsEdit({
          disabled: false,
          edit: false,
        });
        setConfigIsEdit(false);
        setClient({});
      } catch (e) {
        enqueueSnackbar(e?.message, {
          variant: "error",
        });
      }
    } else {
      try {
        payload.clientId = parseInt(id);
        let result = await TLinkApi.post("clients/securityConfig", payload);
        enqueueSnackbar(result?.message, {
          variant: "success",
        });
        navigate(`/clients/${id}/clientFilters/edit`);
        setIsLoading(false);
        setIsEdit({
          disabled: false,
          edit: false,
        });
        setConfigIsEdit(false);
        setClient({});
      } catch (e) {
        enqueueSnackbar(e?.message, {
          variant: "error",
        });
      }
    }
  };

  const getClientSecurityConfiguration = async () => {
    setIsLoading(true);
    try {
      let result = await TLinkApi.get(`clients/${id}/securityConfig`);
      if (result && Object.keys(result).length > 0) {
        setIsEdit({
          disabled: true,
          edit: false,
        });
        setConfigIsEdit(true);

        reset({
          minLoi: result.minLoi,
          maxLoi: result.maxLoi,
          uniqueIp: result.uniqueIp,
          countryMismatch: result.countryMismatch,
          researchDefender: result.researchDefender,
          uniqueUser: result.uniqueUser,
          deviceFingerprint: result.deviceFingerprint,
          blockedIp: result.blockedIp,
          verisoulDecision: result.verisoulDecision,
          verisoulEnable: result.verisoulEnable,
          personaFingerprint: result.personaFingerprint,
          researchDefenderScore: result.researchDefenderScore,
          minLoiIsActive: Boolean(result.minLoi),
          maxLoiIsActive: Boolean(result.maxLoi),
          digitalFingerprint: result.digitalFingerprint,
          groupDeduplicationUniqueIp: result.groupDeduplicationUniqueIp,
          groupDeduplicationUniqueUser: result.groupDeduplicationUniqueUser,
          duplicateToggle: result.duplicateToggle,
          rdDuplicateScore: result.rdDuplicateScore,
          blockedUser: result.blockedUser,
        });

        // setValue("minLoi", 21);
        // setValue("maxLoi", 32);
        // setValue("uniqueIp", result.uniqueIp);
        // setValue("countryMismatch", result.countryMismatch);
        // setValue("researchDefender", result.researchDefender);
        // setValue("uniqueUser", result.uniqueUser);
        // setValue("researchDefenderScore", result.researchDefenderScore);
        // setValue("minLoiIsActive", Boolean(result.minLoi));
        // setValue("maxLoiIsActive", Boolean(result.maxLoi));
        // setValue(
        //   "digitalFingerprint",
        //   result.digitalFingerprint
        // );
        // setValue(
        //   "groupDeduplicationUniqueIp",
        //   result.groupDeduplicationUniqueIp
        // );
        // setValue(
        //   "groupDeduplicationUniqueUser",
        //   result.groupDeduplicationUniqueUser
        // );
        // setValue("duplicateToggle", result.duplicateToggle);
        // setValue("rdDuplicateScore", result.rdDuplicateScore);
        // setValue("blockedUser", result.blockedUser);
      } else {
        setIsEdit({
          disabled: false,
          edit: true,
        });
      }
      setIsLoading(false);
    } catch (e) {
      setIsEdit({
        disabled: false,
        edit: true,
      });
      console.log(e);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (id) getClientSecurityConfiguration();
    // eslint-disable-next-line
  }, [id]);

  useEffect(() => {
    if (watch("verisoulEnable") === false) setValue("verisoulDecision", "");
  }, [watch("verisoulEnable")]);

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <form onSubmit={handleSubmit(save)} noValidate>
        <MDBox
          style={{
            borderRadius: "16px",
            background: "white",
            minHeight: "700px",
          }}
          p={3}
          m={2}
        >
          <MDBox display="flex" justifyContent="flex-end" pb={2}>
            {isEdit.disabled !== false && (
              <IconButton
                color="dark"
                size="small"
                onClick={() => {
                  setIsEdit({
                    disabled: false,
                    edit: true,
                  });
                }}
              >
                <Icon>border_color_icon</Icon>
              </IconButton>
            )}
          </MDBox>
          <MDBox sx={{ overflowY: "auto" }}>
            <DeduplicationClient
              uniqueIp={uniqueIp}
              uniqueUser={uniqueUser}
              personaFingerprint={watch("personaFingerprint")}
              deviceFingerprint={watch("deviceFingerprint")}
              digitalFingerprint={digitalFingerprint}
              setValue={setValue}
              isEdit={isEdit}
            />
            <GroupDeduplicationClient
              uniqueIp={watch("groupDeduplicationUniqueIp")}
              uniqueUser={watch("groupDeduplicationUniqueUser")}
              setValue={setValue}
              isEdit={isEdit}
            />
            <ResearchDefenderClient
              researchDefender={researchDefender}
              duplicate={watch("duplicateToggle")}
              control={control}
              setValue={setValue}
              isEdit={isEdit}
            />
            <OtherSecurityClient
              researchDefender={researchDefender}
              countryMismatch={countryMismatch}
              blockedIp={watch("blockedIp")}
              blockedUser={watch("blockedUser")}
              errors={errors}
              control={control}
              setValue={setValue}
              isEdit={isEdit}
            />
            <MDBox
              p={2}
              style={{ border: "1px solid #D9D9D9", borderRadius: "16px" }}
              mt={2}
            >
              <MDTypography variant="h6" fontWeight="medium" color="textColor">
                {"Validation"}
              </MDTypography>
              <MDBox mt={0.5}>
                <hr style={{ border: "1px solid #e0e0e0", width: "100%" }} />
              </MDBox>
              <Grid container spacing={3} px={2} pt={2}>
                <Grid
                  item
                  xs={12}
                  md={12}
                  lg={6}
                  display="flex"
                  alignItems="center"
                  justifyContent="flex-start"
                >
                  <MDBox ml={0.5}>
                    <MDTypography
                      variant="button"
                      fontWeight="regular"
                      color="dark"
                      fontSize="12px"
                    >
                      Min LoI (%) :&nbsp;&nbsp;
                    </MDTypography>
                  </MDBox>
                  <MDBox mt={0.5}>
                    <Switch
                      checked={minLoiIsActive}
                      onChange={(e, value) => {
                        setValue("minLoiIsActive", value);
                      }}
                      disabled={isEdit.disabled}
                    />
                  </MDBox>
                  <Controller
                    name="minLoi"
                    control={control}
                    rules={{
                      required: minLoiIsActive
                        ? "Min LoI (%) is required!"
                        : false,
                    }}
                    render={({ field }) => (
                      <MDInput
                        {...field}
                        type="number"
                        fullWidth
                        required
                        sx={{ width: "200px" }}
                        {...register("minLoi", {
                          min: 0,
                          max: maxLoi,
                        })}
                        autoComplete="off"
                        variant="outlined"
                        disabled={isEdit.disabled || !minLoiIsActive}
                        error={errors?.minLoi ? true : false}
                        helperText={
                          errors?.minLoi && errors.minLoi.message !== ""
                            ? errors.minLoi.message
                            : errors?.minLoi?.type === "min" ||
                              errors?.minLoi?.type === "max"
                            ? minLoiIsActive
                              ? "Check Min Value should be greater than max"
                              : null
                            : null
                        }
                      />
                    )}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={12}
                  lg={6}
                  display="flex"
                  alignItems="flex-start"
                  justifyContent="flex-start"
                >
                  <MDBox ml={0.5}>
                    <MDTypography
                      variant="button"
                      fontWeight="regular"
                      color="dark"
                      fontSize="12px"
                    >
                      Max LoI (%) :&nbsp;&nbsp;
                    </MDTypography>
                  </MDBox>
                  <MDBox mt={0.5}>
                    <Switch
                      checked={maxLoiIsActive}
                      onChange={(e, value) => {
                        setValue("maxLoiIsActive", value);
                      }}
                      disabled={isEdit.disabled}
                    />
                  </MDBox>
                  <Controller
                    name="maxLoi"
                    control={control}
                    rules={{
                      required: maxLoiIsActive
                        ? "Max LoI (%) is required!"
                        : false,
                    }}
                    render={({ field }) => (
                      <MDInput
                        {...field}
                        sx={{ width: "200px" }}
                        type="number"
                        disabled={isEdit.disabled || !maxLoiIsActive}
                        {...register("maxLoi", {
                          min: minLoi,
                        })}
                        required
                        autoComplete="off"
                        variant="outlined"
                        error={errors?.maxLoi ? true : false}
                        helperText={
                          errors?.maxLoi && errors.maxLoi.message !== ""
                            ? errors.maxLoi.message
                            : errors?.maxLoi?.type === "min" ||
                              errors?.maxLoi?.type === "max"
                            ? maxLoiIsActive
                              ? "Check Min Value should be smaller than max"
                              : null
                            : null
                        }
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </MDBox>
            <MDBox
              p={2}
              style={{ border: "1px solid #D9D9D9", borderRadius: "16px" }}
              mt={2}
            >
              <MDTypography variant="h6" fontWeight="medium" color="textColor">
                {"Verisoul"}
              </MDTypography>
              <MDBox mt={0.5}>
                <hr style={{ border: "1px solid #e0e0e0", width: "100%" }} />
              </MDBox>
              <Grid container spacing={3} px={2} pt={2}>
                <Grid
                  item
                  xs={12}
                  md={12}
                  lg={6}
                  display="flex"
                  alignItems="center"
                  justifyContent="flex-start"
                >
                  <MDBox ml={0.5}>
                    <MDTypography
                      variant="button"
                      fontWeight="regular"
                      color="dark"
                      fontSize="12px"
                    >
                      Verisoul :&nbsp;&nbsp;
                    </MDTypography>
                  </MDBox>
                  <MDBox mt={0.5}>
                    <Switch
                      checked={watch("verisoulEnable")}
                      onChange={(e, value) => {
                        setValue("verisoulEnable", value);
                      }}
                      disabled={isEdit.disabled}
                    />
                  </MDBox>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={12}
                  lg={6}
                  display="flex"
                  alignItems="flex-start"
                  justifyContent="flex-start"
                >
                  <MDBox ml={0.5}>
                    <MDTypography
                      variant="button"
                      fontWeight="regular"
                      color="dark"
                      fontSize="12px"
                    >
                      Verisoul Decision :&nbsp;&nbsp;
                    </MDTypography>
                  </MDBox>

                  <Controller
                    name="verisoulDecision"
                    control={control}
                    rules={{
                      required: watch("verisoulEnable")
                        ? "Verisoul Decision is required!"
                        : false,
                    }}
                    render={({ field }) => (
                      <FormControl
                        sx={{ width: "200px" }}
                        error={!!errors?.verisoulDecision}
                      >
                        <Select
                          {...field}
                          multiple
                          sx={{ height: "35px" }}
                          disabled={isEdit.disabled || !watch("verisoulEnable")}
                          value={field.value ? field.value.split(",") : []}
                          onChange={(e) => {
                            const value = e.target.value;
                            field.onChange(value.join(","));
                          }}
                          displayEmpty
                          renderValue={(selected) =>
                            selected.length === 0
                              ? "Select Decision"
                              : selected.join(", ")
                          }
                        >
                          {OPTIONS.map((option) => (
                            <MenuItem key={option} value={option}>
                              <Checkbox
                                checked={
                                  field.value
                                    ? field.value.split(",").includes(option)
                                    : false
                                }
                              />
                              {option}
                            </MenuItem>
                          ))}
                        </Select>

                        {errors?.verisoulDecision && (
                          <p
                            style={{
                              color: "#d32f2f",
                              fontSize: "12px",
                              marginTop: "4px",
                            }}
                          >
                            {errors.verisoulDecision.message}
                          </p>
                        )}
                      </FormControl>
                    )}
                  />
                </Grid>
              </Grid>
            </MDBox>
          </MDBox>
        </MDBox>
        {isEdit.disabled !== true && (
          <MDBox
            pt={2}
            px={2}
            mb={2}
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            gap="10px"
          >
            <MDButton
              variant="outlined"
              color="dark"
              onClick={() => {
                setIsEdit({
                  disabled: false,
                  edit: false,
                });
                setClient({});
                navigate("/clients");
              }}
            >
              &nbsp;cancel
            </MDButton>
            <MDButton variant="gradient" color="info" type="submit">
              Save
            </MDButton>
          </MDBox>
        )}
      </form>
      {isEdit.disabled === true && (
        <MDBox
          py={2}
          px={2}
          mb={2}
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          gap="10px"
        >
          <MDButton
            variant="outlined"
            color="dark"
            onClick={() => {
              setIsEdit({
                disabled: false,
                edit: false,
              });
              setClient({});
              navigate("/clients");
            }}
          >
            &nbsp;cancel
          </MDButton>
          <MDButton
            variant="gradient"
            color="info"
            onClick={() => {
              setIsEdit({
                disabled: false,
                edit: true,
              });
              setClient({});
              navigate(`/clients/${id}/clientFilters/edit`);
            }}
          >
            Next
          </MDButton>
        </MDBox>
      )}
    </>
  );
};

export default SecurityConfiguration;
